import {useCallback} from 'react';

import {useTranslation} from 'react-i18next';
import {showSuccess, showError} from '@phonectas/unifon-ui-kit';

/**
 * Custom hook to copy text to clipboard.
 * @return {Array} An array containing the copy status and the copy function.
 */
export function useCopyToClipboard(): [(text: string, successMsg?: string) => Promise<void>] {
	const [t] = useTranslation();

	const copyToClipboard = useCallback(
		async (text: string, successMsg?: string): Promise<void> => {
			if (!navigator.clipboard) {
				console.error('Clipboard API not available');
				showError({
					message: t('Failed to copy text, try again'),
				});
				return;
			}

			try {
				await navigator.clipboard.writeText(text);
				showSuccess({
					message: successMsg || t('Copied to clipboard'),
				});
			} catch (err) {
				console.error('Failed to copy text: ', err);
				showError({
					message: t('Failed to copy text, try again'),
				});
			}
		},
		[t]
	);

	return [copyToClipboard];
}

